<template>
  <main class="wrapper">
    <section class="montageInformation">
      <p>ООО "ОБЛГАЗСЕРВИС-СЕВЕР" выполняет весь перечень работ по монтажу котельного оборудования. Оценочная стоимость работ по монтажу - <span class="red">15% от стоимости оборудования</span>.
      </p>
      <app-document>
        <h1 class="docHeader">Расценки на монтаж и ТО</h1>
        <template v-slot:pdf>
          <a href="https://drive.google.com/file/d/1kRjpwLmFPN3UgTxE_Txek0Ep6Mye-GKn/view?usp=sharing" target="_blank">
            <img class="docImg" src="../img/pdf.webp" alt="иконка пдф">
          </a>
        </template>
      </app-document>
      <img src="../img/boiler-service.webp" alt="монтаж котельной">
      <div class="info">
        <p>
          Для получения точной сметы на работы необходимо знать:
        </p>
        <ol>
          <li>Тип и мощность котла(навесной, напольный ...),</li>
          <li>Материал трубы обвязки котельной,</li>
          <li>Схему (проект) котельной.</li>
        </ol>
      </div>
    </section>
    <h1>Сколько действует гарантия?</h1>
    <h2><em>Гарантийные обязательства фирмы VIESSMANN</em></h2>
    <blockquote>
      <p><em>"...3. Монтаж и пуск Оборудования в эксплуатацию.</em></p>
      <p><em>
        3.1 Заказчик обязан заключить договор на монтаж и ввод Оборудивания в эксплуатацию с сертифицированной и допущенной организацией из числа сервисных центров ООО "ВИССМАНН"
      </em></p>
      <p><em>
        3.4 Организация, производившая пусконаладочные работы, при пуске Оборудования в эксплуатацию, заполняет протокол ввода (акт) Оборудования в эксплуатацию, ставит дату и печать организации. Гарантийный период, при наличии заполненного паспорта,
        данных о продаже и пусконаладочных работах, а также заполненного Протокола (акта) о пуске или вводе Оборудования в эксплуатацию, составляет <span class="green"> 24 месяца от даты ввода Оборудования в эксплуатацию, но не более 27 месяцев с даты отгрузки со склада Продавца </span>."
      </em></p>
    </blockquote>
    <h1>Что такое конденсационные котлы?</h1>
    <p>
      Конденсационные котлы работают за счёт тепловой энергии сжигания топлива и дополнительной энергии, выделяющейся при переходе пара в воду. Такой принцип работы обеспечивает максимальную экономию топлива. При подключении такого котла к низкотемпературной
      системе можно добиться снижения расхода топлива на 20%.
    </p>
    <p>
      Например, для котла можностью 60 кВт при стоимости природного газа 4.8 руб/куб экономия составит <span class="green">4 000 руб/мес</span>. Для сжиженного газа экономия составит уже <span class="green">12 000 руб/мес</span>, а для дизтоплива - <span class="green">20 000 руб/мес</span>! По сравнению с напольными котлами,
      конденсационные котлы намного компактнее. Из-за дымохода меньшего диаметра возможен отвод непосредственно через стену на улицу.
    </p>
    <p>
      Конденсационные котлы используются в системах радиаторного отопления и теплых полов. Для систем радиаторного отпления расчётная температура + 70 градусов (подающая линия) и + 50 градусов (обратная линия). Условия конденсации определяются температурой воды в обратной линии -
      необходимо, чтобы она не превышала температуру точки росы. Для тёплого пола с температурным режимом + 40/30 градусов повышается полнота конденсации, так как температура обратной воды в отопительный сезон всегда оказывается ниже, чем температура
      точки росы; в этих условиях котлы функционируют наиболее эффективно.
    </p>
    <h1>Какой материал трубы выбрать?</h1>
    <p>
      На основании многолетнего опыта, наши приоритеты по материалам следующие:
    </p>
    <ol>
      <li><span class="green">Медь - лучший материал по всем параметрам</span></li>
      <li>Металлопластик</li>
      <li>Сшитый полиэтилен</li>
    </ol>
    <p>
      Стоимость трубы, коллекторов и фитингов составляет примерно <span class="green">25-30%</span> от стоимости всей системы отопления (без оборудования котельной). Если принять стоимость системы отопления с металлопластиковой трубой за 1, то стоимость системы на базе сшитого полиэтилена больше в <span class="red">1.4 раза</span>,
      а стоимость на медной трубе выше в <span class="red">1.5-1.7 раз</span>. Однако, такая цена на медь оправдана за счёт её наилучших эксплуатационных характеристик по сравнению с другими материалами.
    </p>
    <table>
      <tbody>
      <tr>
        <th colspan="4">Сравнение материалов</th>
      </tr>
      <tr>
        <th></th>
        <th>Медь</th>
        <th>Металлопластик</th>
        <th>Сшитый полиэтилен</th>
      </tr>
      <tr>
        <td>Надёжность</td>
        <td><span class="green">++</span></td>
        <td>+</td>
        <td>+</td>
      </tr>
      <tr>
        <td>Удобство монтажа</td>
        <td><span class="green">++</span></td>
        <td>+</td>
        <td>+</td>
      </tr>
      <tr>
        <td>Ремонтопригодность</td>
        <td><span class="green">+++</span></td>
        <td>++</td>
        <td>+</td>
      </tr>
      <tr>
        <td>Использование антифриза</td>
        <td><span class="green">+</span></td>
        <td>-</td>
        <td>+/-</td>
      </tr>
      <tr>
        <td>Цена</td>
        <td>-</td>
        <td><span class="green">+</span></td>
        <td>+/-</td>
      </tr>
      <tr>
        <td>Устойчивость к агрессивным средам</td>
        <td><span class="green">++</span></td>
        <td>-</td>
        <td>-</td>
      </tr>
      <tr>
        <td>Стойкость к заиливанию и зарастанию</td>
        <td>+</td>
        <td>+</td>
        <td>+</td>
      </tr>
      <tr>
        <td>Устойчивость к коррозии и антитоксичность</td>
        <td>+</td>
        <td>+</td>
        <td>+</td>
      </tr>
      <tr>
        <td>Открытая разводка</td>
        <td><span class="green">+</span></td>
        <td>+/-</td>
        <td>-</td>
      </tr>
      </tbody>
    </table>
    <section class="tabs">
      <button :class = "{tab: true, active: toggleCopper === true}" @click="$router.push('/montage/copperPipe'); clickCopper()">
        Медь
      </button>
      <button :class = "{tab: true, active: togglePlastic === true}" @click="$router.push('/montage/plasticPipe'); clickPlastic()">
        Пластик
      </button>
    </section>
    <transition name="slide-pageTransition" mode="out-in">
      <router-view></router-view>
    </transition>
  </main>
</template>

<script>
  import {useRoute} from "vue-router";
  import {ref} from "@vue/reactivity";
  import AppDocument from "@/components/AppDocument";

  export default {

    components: {AppDocument},

    setup() {
      const router = useRoute()

      let route = router.path
      let toggleCopper = ref (false)
      let togglePlastic = ref (false)

      if (route === '/montage/copperPipe') {
        toggleCopper.value = true
      } else {
        togglePlastic.value =true
      }

      function clickCopper() {
        toggleCopper.value = true
        togglePlastic.value = false
      }

      function clickPlastic() {
        toggleCopper.value = false
        togglePlastic.value = true
      }

      return {
        toggleCopper,
        togglePlastic,
        clickCopper,
        clickPlastic,
      }

    }
  }
</script>

<style scoped>

  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .montageInformation {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: auto;
    margin-top: 30px;
  }

   img {
    width: 55%;
    height: auto;
  }

  .info {
    width: 100%;
  }

  p {
    text-align: justify;
    text-indent: 50px;
    padding: 10px;
    font-size: 2em;
    margin-left: 5%;
    margin-right: 5%;
  }

  a {
    text-transform: uppercase;
  }

  h2 {
    margin-top: 20px;
    margin-bottom: 0;
  }

  blockquote p {
    margin: 0;
  }

  ol {
    margin-left: 5%;
  }

  ol li {
    margin: 10px;
    font-size: 2em;
  }

  h1 {
    font-size: 2.5em;
    text-align: center;
    font-family: "Poppins", sans-serif !important;
  }

  button {
    border: 0;
  }

  .tabs {
    margin-top: 20px;
    text-align: center;
  }

  table {
    margin-left: 5%;
    margin-right: 5%;
  }

  .montage-pageTransition-enter-from {
    transform: translateX(30px);
    opacity: 0;
  }
  .montage-pageTransition-leave-to {
    transform: translateX(-30px);
    opacity: 0;
  }
  .montage-pageTransition-enter-active, .montage-pageTransition-leave-active {
    transition: all 1s ease;
  }

  @media (max-width: 1400px) {
    .tab {
      width: 35vw;
      font-size: 1.5em;
    }

    img {
      width: 90%;
    }
  }

  @media (max-width: 800px) {
    h1, h2 {
      font-size: 1.7em;
    }

    p, ol li {
      font-size: 1.2em;
    }

  }

  @media (max-width: 400px) {

    h1, h2 {
      font-size: 1.5em;
    }

    .tab {
      width: 40vw;
      font-size: 1em;
    }

    table {
      display: none;
    }

    img {
      width: 100%;
      margin-bottom: 20px;
    }

    p, ol li {
      font-size: 1em;
    }

    blockquote {
      margin-left: 5%;
      margin-right: 5%;
    }

    h1, h2 {
      margin-left: 5%;
      margin-right: 5%;
    }
  }

</style>